import React, { createContext, useContext, useMemo } from 'react';
import { resolveActiveTheme, themeToCssVars } from '../theme/resolveTheme';
import { defaultThemeFile } from '../theme/defaultTheme';

const ThemeContext = createContext({
  darkMode: false,
  theme: null,
  themeFile: defaultThemeFile,
  cssVars: {},
});

/**
 * Applies parent theme + darkMode to the whole package via CSS variables on `.ca-root`.
 *
 * @param {object} [theme] - Static theme file / tokens from parent
 * @param {boolean} [darkMode=false] - Parent-controlled dark mode flag
 */
export function ThemeProvider({ theme, darkMode = false, children }) {
  const value = useMemo(() => {
    const active = resolveActiveTheme(theme, Boolean(darkMode));
    const cssVars = themeToCssVars(active);
    return {
      darkMode: Boolean(darkMode),
      theme: active,
      themeFile: active.__pack,
      cssVars,
      mode: active.mode,
    };
  }, [theme, darkMode]);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeContext;
